import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';

export function setAguardando(aguardando) {
    return {
        type: 'DASHBOARD_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function setFiltro(filtro) {
    return {
        type: 'DASHBOARD_SET_FILTRO',
        payload: filtro
    };
}

export function getListaDespesa() {
	return (dispatch, getState) => {

        const filtro = getState().dashboard.filtro;

		axios.get(`${consts.API_URL}/despesa/dashboard?padrao=true
            &pago=true
            &data_inicial=${getState().dashboard.filtro.data_inicial}
            &data_final=${getState().dashboard.filtro.data_final}
            ${(filtro.ids_empresa || []).length ? `&ids_empresa=${filtro.ids_empresa.join(',')}` : ''}
            ${(filtro.ids_centro_custo || []).length ? `&ids_centro_custo=${filtro.ids_centro_custo.join(',')}` : ''}
            ${(filtro.ids_fornecedor || []).length ? `&ids_fornecedor=${filtro.ids_fornecedor.join(',')}` : ''}
            ${(filtro.ids_analitica || []).length ? `&ids_analitica=${filtro.ids_analitica.join(',')}` : ''}
            ${(filtro.ids_forma_pagamento || []).length ? `&ids_forma_pagamento=${filtro.ids_forma_pagamento.join(',')}` : ''}
            ${(filtro.ids_destinatario || []).length ? `&ids_origem=${filtro.ids_destinatario.join(',')}` : ''}
        `).then(result => {
			dispatch({
				type: 'DASHBOARD_DESPESA_PAGA_LISTADO',
				payload: result
			});
		}).catch(ex => {
			setErroAPI(ex);
		});
	};
}

export function getListaContaPagar() {
	return (dispatch, getState) => {

        const filtro = getState().dashboard.filtro;

		axios.get(`${consts.API_URL}/despesa/dashboard?padrao=true
            &data_inicial=${getState().dashboard.filtro.data_inicial}
            &data_final=${getState().dashboard.filtro.data_final}
            ${(filtro.ids_empresa || []).length ? `&ids_empresa=${filtro.ids_empresa.join(',')}` : ''}
            ${(filtro.ids_centro_custo || []).length ? `&ids_centro_custo=${filtro.ids_centro_custo.join(',')}` : ''}
            ${(filtro.ids_fornecedor || []).length ? `&ids_fornecedor=${filtro.ids_fornecedor.join(',')}` : ''}
            ${(filtro.ids_analitica || []).length ? `&ids_analitica=${filtro.ids_analitica.join(',')}` : ''}
            ${(filtro.ids_forma_pagamento || []).length ? `&ids_forma_pagamento=${filtro.ids_forma_pagamento.join(',')}` : ''}
            ${(filtro.ids_destinatario || []).length ? `&ids_origem=${filtro.ids_destinatario.join(',')}` : ''}
        `).then(result => {
			dispatch({
				type: 'DASHBOARD_CONTA_PAGAR_LISTADO',
				payload: result
			});
		}).catch(ex => {
			setErroAPI(ex);
		});
	};
}

export function getListaReceita() {
	return (dispatch, getState) => {

        const filtro = getState().dashboard.filtro;
        
		axios.get(`${consts.API_URL}/receita/dashboard?padrao=true
            &pago=true
            &data_inicial=${filtro.data_inicial}
            &data_final=${filtro.data_final}
            ${(filtro.ids_empresa || []).length ? `&ids_empresa=${filtro.ids_empresa.join(',')}` : ''}
            ${(filtro.ids_centro_custo || []).length ? `&ids_centro_custo=${filtro.ids_centro_custo.join(',')}` : ''}
            ${(filtro.ids_analitica || []).length ? `&ids_analitica=${filtro.ids_analitica.join(',')}` : ''}
            ${(filtro.ids_forma_pagamento || []).length ? `&ids_forma_pagamento=${filtro.ids_forma_pagamento.join(',')}` : ''}
            ${(filtro.ids_destinatario || []).length ? `&ids_destinatario=${filtro.ids_destinatario.join(',')}` : ''}
        `).then(result => {
			dispatch({
				type: 'DASHBOARD_RECEITA_RECEBIDA_LISTADO',
				payload: result
			});
		}).catch(ex => {
			setErroAPI(ex);
		});
	};
}

export function getListaContaReceber() {
	return (dispatch, getState) => {
        
        const filtro = getState().dashboard.filtro;

		axios.get(`${consts.API_URL}/receita/dashboard?padrao=true
            &data_inicial=${getState().dashboard.filtro.data_inicial}
            &data_final=${getState().dashboard.filtro.data_final}
            ${(filtro.ids_empresa || []).length ? `&ids_empresa=${filtro.ids_empresa.join(',')}` : ''}
            ${(filtro.ids_centro_custo || []).length ? `&ids_centro_custo=${filtro.ids_centro_custo.join(',')}` : ''}
            ${(filtro.ids_analitica || []).length ? `&ids_analitica=${filtro.ids_analitica.join(',')}` : ''}
            ${(filtro.ids_forma_pagamento || []).length ? `&ids_forma_pagamento=${filtro.ids_forma_pagamento.join(',')}` : ''}
            ${(filtro.ids_destinatario || []).length ? `&ids_destinatario=${filtro.ids_destinatario.join(',')}` : ''}
        `).then(result => {
			dispatch({
				type: 'DASHBOARD_CONTA_RECEBER_LISTADO',
				payload: result
			});
		}).catch(ex => {
			setErroAPI(ex);
		});
	};
}
